
import React, { useCallback, useMemo, useRef } from "react";
import { App } from "@codeArt/apps";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { requestUrl } from "@codeArt/utils/url";
import { to } from "@codeArt/utils/promise";
import { useDispatch, useSelector } from "react-redux";
import { fileUrl, main, uploadUrl } from "project/constant/host";
import _ from "lodash";
import { request } from "@codeArt/request";
import { activate, filter as filterPlugins, registerContext } from "@codeArt/extension";
import { getPredicate } from "@codeArt/apps/page/extension";
import { ExplorerConfig, getSrc } from '@codeArt/components/explorer/index'
import { fetchError } from "redux/actions";

const SolutionApp = (props) => {
  const dispatch = useDispatch();

  const { match, location, solutionId } = props;

  const initPlugin = () => {  //初始化插件
    registerContext("project", { //向上下文中注册成员
      id: solutionId
    });
  }

  const init = async success => {

    // 初始化文件上传的相关配置
    ExplorerConfig.set({
      domain: uploadUrl,
      getDirectory: "/GetSolutionDirectory",
      getRoots: "/GetSolutionExplorerRoots",
      getVirtualDirectory: "/GetSolutionVirtualDirectory",
      getRootDirectory: "/GetSolutionRootDirectory",
      getItems: "/GetSolutionExplorerItems",
      createDirectory: "/CreateSolutionDirectory",
      "delete": "/DeleteSolutionExplorerItems",
      rename: "/RenameSolutionExplorerItem",
      moveFiles: "/MoveSolutionFiles",
    });

    initPlugin();
    success();
  };

  const dispose = success => {
    success();
  }

  const load = useCallback(
    (success) => {
      request(
        {
          url: "/GetSolution",
          data: { id: solutionId, slim:true },
          success: r => {
            let {Name,Photo} = r;
            let url = getSrc(Photo,{width:0,height:0,domain:fileUrl});
            success({
              logo: {
                lg: {
                  size: ["auto", 38]
                },
                url: url,
                name: Name
              }
            });
          }
        },
        dispatch);
    },[]);

  return (
    <App
      name="solution"
      data={{ solutionId }}
      request={{ domain: main, upload: uploadUrl}}
      extension={{ getPredicate: () => getPredicate(solutionId) }}  //solutionId就是插件管理器的编号
      auth={{ data: { solutionId } }}
      init={init}
      load={load}
      dispose={dispose}
      dispatch={dispatch}
      {...props}
    >
    </App>
  );
};

export default SolutionApp;